

import * as React from 'react';

type TestingProps = {
}

const Testing: React.FC<TestingProps> = () => {

    const [testingHtml, setTestingHtml] = React.useState<string | null>(null);

    React.useEffect(() => {
        // Simulate fetching HTML content
        const fetchHtmlContent = async () => {
            // Replace with actual fetch logic if needed
            const response = await fetch(process.env.BACKEND_ROOT + '/api/testing');
            const htmlContent = await response.text();
            setTestingHtml(htmlContent);
        };

        fetchHtmlContent();
    }, []);

  return (
    <div dangerouslySetInnerHTML={{ __html: (testingHtml ?? "") }} />
  );
};

export default Testing;